import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Instagram, Facebook, Linkedin, Mail } from "lucide-react";
import { TikTok } from "@/components/icons/TikTok";
import kokoomusLogo from "@/assets/kokoomus-logo.png";

const navItems = [
  { path: "/lotta", label: "Lotta" },
  { path: "/politiikka", label: "Politiikka" },
  { path: "/osaaminen", label: "Osaaminen" },
  { path: "/blogi", label: "Blogi" },
  { path: "/ota-yhteytta", label: "Ota yhteyttä" },
];

const socialLinks = [
  { href: "https://www.instagram.com/ellosenlotta", icon: Instagram, label: "Instagram" },
  { href: "https://www.facebook.com/lottaellonen", icon: Facebook, label: "Facebook" },
  { href: "https://www.linkedin.com/in/lottaellonen", icon: Linkedin, label: "LinkedIn" },
  { href: "https://www.tiktok.com/@morrikka_", icon: TikTok, label: "TikTok" },
  { href: "mailto:sinisellasydamella@gmail.com", icon: Mail, label: "Email" },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="fixed inset-x-0 top-0 z-50 bg-[hsl(42,86%,72%)]">
      <div className="h-[3px] bg-gradient-to-r from-primary via-primary/40 to-transparent" />

      <div className="flex h-28 items-center justify-between px-6 lg:px-10">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <img src={kokoomusLogo} alt="Logo" className="h-10 w-auto" />
          <span className="flex flex-col text-xl leading-tight text-secondary-foreground">
            <span className="hero-title-lotta">Lotta</span>
            <span className="hero-title-ellonen">Ellonen</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-7 lg:flex">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-base transition-colors ${
                pathname === item.path
                  ? "font-bold text-primary-foreground underline decoration-yellow-100 decoration-2 underline-offset-[10px]"
                  : "font-medium text-primary-foreground/80 hover:text-primary-foreground"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-1.5 lg:flex">
          {socialLinks.map(({ href, icon: Icon, label }) => (
            <a
              key={label}
              href={href}
              target={label !== "Email" ? "_blank" : undefined}
              rel="noopener noreferrer"
              aria-label={label}
              className="rounded-lg bg-white/90 p-2 text-primary transition-transform hover:-translate-y-0.5"
            >
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="rounded-lg p-2 text-primary-foreground lg:hidden"
          aria-label="Valikko"
        >
          {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {isOpen && (
        <div className="border-t border-primary-foreground/20 bg-primary lg:hidden">
          <nav className="space-y-1 px-6 py-4">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block rounded-xl px-4 py-3 text-sm font-medium ${
                  pathname === item.path
                    ? "bg-white/20 text-primary-foreground"
                    : "text-primary-foreground/90 hover:bg-white/10"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="flex gap-2 px-4 pt-3">
              {socialLinks.map(({ href, icon: Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target={label !== "Email" ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="rounded-lg bg-white/90 p-2.5 text-primary"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
